// import "@esri/calcite-components/dist/calcite/calcite.css";
import { defineCustomElements } from "@esri/calcite-components/dist/loader";
defineCustomElements(window);

import "@a11y/focus-trap";

import App from "./app/App";
import UnsupportedBrowser from "./app/ui/unsupported/UnsupportedBrowser";

import "./main.scss";

import appConfigJSON from "./config/appConfig.json";
import {
  createJSONLoader,
  registerMessageBundleLoader,
} from "@arcgis/core/intl";
import { decideAndSetLocale, decideAndSetDir } from "./app/utils/t9nUtils";

(function init() {
  firstLocaleSet();

  const { isIE, isUnsupported } = checkUnsupportedBrowser();
  const browserIsSupported = isUnsupported == null;
  if (!browserIsSupported) {
    new UnsupportedBrowser({
      container: document.body,
      isIE,
    });
    return;
  }

  _handleT9N();

  new App({
    appConfig: appConfigJSON,
    container: "mainDiv",
  });
})();

/**
 * First time we set the locale.
 * Setting this before the Portal sign-in guarantees that the portal sign-in prompt will be localized
 */
function firstLocaleSet() {
  appConfigJSON.locale = decideAndSetLocale();
  appConfigJSON.direction = decideAndSetDir(appConfigJSON.locale);
}

function checkUnsupportedBrowser(): any {
  let isUnsupported = null;
  const userAgent = window.navigator.userAgent;
  const msie = userAgent.indexOf("MSIE ");
  const trident = userAgent.indexOf("Trident/");
  const edge = userAgent.indexOf("Edge/");
  let isIE = false;
  if (msie > 0) {
    isUnsupported = parseInt(
      userAgent.substring(msie + 5, userAgent.indexOf(".", msie)),
      10
    );
    isIE = true;
  }

  if (trident > 0) {
    const rvIndex = userAgent.indexOf("rv:");
    isUnsupported = parseInt(
      userAgent.substring(rvIndex + 3, userAgent.indexOf(".", rvIndex)),
      10
    );
    isIE = true;
  }

  if (edge > 0) {
    isUnsupported = parseInt(
      userAgent.substring(edge + 5, userAgent.indexOf(".", edge)),
      10
    );
  }

  return {
    isUnsupported,
    isIE,
  };
}

function _handleT9N() {
  registerMessageBundleLoader(
    createJSONLoader({
      pattern: "dist/",
      base: "dist",
      location: new URL("./", window.location.href),
    })
  );
}
